import React, { Component } from 'react';

class UC extends Component{

    render(){   
        return(
            <div className="page-container">
                <div className="">Under Construction</div>
            </div>
        );
    }
}

export default UC;